// extracted by mini-css-extract-plugin
export default {"prices_navigation":"Prices_prices_navigation__YqMB5"};